export default __webpack_public_path__ + "static/media/Zip.a9b9d1f9.svg";